import { Flex, Text } from '@chakra-ui/react'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { ModalBase } from '../../../../../components/ModalBase'

interface iModalComunicacao {
  isOpen: boolean
  onClose: () => void
}

export const ModalTag: React.FC<iModalComunicacao> = ({ isOpen, onClose }) => {
  return (
    <ModalBase Titulo='Como utilizar as TAGs' isOpen={isOpen} onClose={onClose} >
      <Flex maxWidth={'53.125rem'} borderTop={'1px solid var(--Gray4)'} borderBottom={'1px solid var(--Gray4)'} padding={'1rem'}>
        <Text fontSize={'.875rem'}>
          Para deixar seus e-mails com uma cara mais personalizada nós criamos algumas TAGs que podem lhe ajudar.
          <br />
          <br />
          Você também pode personalizar com o nome do participante com a TAG <strong>[NOME DO PARTICIPANTE]</strong> ou ainda com o email do gestor do participante com a TAG <strong>[EMAIL DO GESTOR]</strong>.
          <br />
          <br />
          Outras TAGs que podem ser utilizadas são <strong>[DATA INICIO]</strong>, para a data de início do feedback e <strong>[NOME DO FEEDBACK]</strong> para colocar o nome do feedback
          <br />
          <br />
          <strong>Não se esqueça que as TAGs devem ser sempre inseridas entre colchetes [ ], conforme estão escritas no texto acima.</strong>
          <br />
        </Text>
      </Flex>
      <Flex padding={'.5rem'} justifyContent={'center'} alignItems={'center'}>
        <ButtonCmp onClick={onClose} VarColor='Green2'>Ok</ButtonCmp>
      </Flex>
    </ModalBase>
  )
}
